module.exports = __webpack_public_path__ + "static/media/warm_cozy_2.81af6e81.svg";